import { Injectable } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';
@Injectable({
  providedIn: 'root',
})

export class FunctionsService {
  isLoading: boolean = false;
  location: { lat?: number, lng?: number } = {lat:0, lng: 0}

  constructor(
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private platform: Platform,
  ) {}

  async showLoading(message = '') {
    if(this.isLoading) return
    this.isLoading = true;
    await this.loadingCtrl
      .create({
        message: message,
      })
      .then((loading) => {
        loading.present().then((_) => {
          if (!this.isLoading) loading.dismiss();
        });
      });
  }

  async dismissLoading() {
    this.isLoading = false;
    await this.loadingCtrl.dismiss()
  }

  async presentToast(message:string) {
    let toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      position: 'bottom',
      cssClass: 'ion-text-center',
      buttons: [
        {
          icon: 'close',
          role:"cancel"
        },
      ],
    });

    await toast.present();
  }


  async getCurrentLocation() {
    if(this.location.lat) return this.location
    if (Capacitor.getPlatform() == 'web') return this.location
    await Geolocation.checkPermissions().then(async (p) => {
      if(p.location == 'denied') await Geolocation.requestPermissions()
    })

    const coordinates = await Geolocation.getCurrentPosition();
    if(coordinates.coords) {
        this.location.lat = coordinates.coords.latitude
        this.location.lng = coordinates.coords.longitude
    }
    return this.location
  }



}
